const TRANSIENT_OVERLAY_SELECTOR = '.mask, .modal-dialog, .side-panel';

export const removeTransientOverlays = () => {
    document.querySelectorAll(TRANSIENT_OVERLAY_SELECTOR).forEach(element => element.remove());
};
